import React from 'react';

import { Tag } from '../stories/Tag';

type Props = {
  status: 'current' | 'done' | 'blocked';
};

const LevelListItemTag: React.FC<Props> = (props) => {
  if (props.status === 'current') {
    return null;
  }

  let tagArgs = {};
  if (props.status === 'done') {
    tagArgs = { icon: 'check', variant: 'green-main' };
  } else if (props.status === 'blocked') {
    tagArgs = { icon: 'lock', variant: 'black-medium' };
  }

  return <Tag shape="vertical-badge" size="md" {...tagArgs} />;
};

export default LevelListItemTag;
